import { ODataParameters, Pagination } from "components/http/rest/restEndpoint";
import { isInteger } from "components/utils";
import { DataSource, FilterModel, SortModel } from "./DataSource";

function replaceAll(source: string, find: string, replace: string) {
    let val = source;
    let prev_val = "";
    while (prev_val != val && val != "") {
        prev_val = val;
        val = val.replace(find, replace);
    }
    return val;
}

export class SimpleDataSource<T> extends DataSource<T> {

    private data: T[];
    private onSortFunction: any;

    constructor() {
        super();
        this.data = [];
        this.onSortFunction = null;
    }

    public setData = (data: T[]) => {
        this.data = data;
        this.fetch();
    }

    public setOnSortFunction = (func: any) => {
        this.onSortFunction = func;
    }

    protected fetchData(): void {
        this.fetchSuccess({ data: this.data, itemsCount: this.data.length });
    }

    public onSort = (sort?: SortModel, reset?: boolean): void => {
        const newSortedItems: { [index: string]: SortModel } = (reset === false) ? { ...this.state.sortedItems } : {};

        if (sort !== undefined) {
            newSortedItems[sort.field] = { field: sort.field, direction: sort.direction === 'desc' ? 'desc' : 'asc' };
        }

        this.setState({ ...this.state, currentPage: 0, sortedItems: newSortedItems });
        if (this.onSortFunction !== null) {
            this.onSortFunction();
        }
    };

    public getQueryParameters(): ODataParameters {
        const pageSize = this.state.pageSize;
        const pagination: Pagination = pageSize == null || pageSize == 0 ?
            null :
            { pageNumber: this.state.currentPage, pageSize };

        const sortSpecification = this.state.sortedItems;
        const sortFields = Object.keys(sortSpecification);
        const orderby: string = sortFields.length == 0 ?
            null :
            sortFields
                .map(field => {
                    const field_modified = replaceAll(sortSpecification[field].field, ".", "/");
                    const direction = sortSpecification[field].direction;
                    return `${field_modified} ${direction}`;
                })
                .join(",");

        const filterSpecification = this.state.filteredItems;
        const filterFields = Object.keys(filterSpecification);
        let filter = filterFields.length == 0 ?
            null :
            filterFields
                .map(field => {
                    const field_modified = replaceAll(field, ".", "/");
                    const filterItem = this.state.filteredItems[field];
                    if (filterItem.value === undefined) {
                        return null;
                    }

                    let value;
                    switch (filterItem.type) {
                        case 'integer':
                            const num = Number(filterItem.value);
                            if (!isFinite(num) || isNaN(num) || !isInteger(num)) {
                                return null;
                            }
                            value = num.toString();
                            break;
                        case 'string':
                        default:
                            value = `'${filterItem.value.toString()}'`;
                            break;

                    }
                    const operator = filterItem.operator;
                    switch (operator) {
                        case 'contains':
                        case 'startswith':
                        case 'endswith':
                            return `${operator}(${field_modified},${value})`;
                        default:
                            return `(${field_modified} ${operator} ${value})`;
                    }
                })
                .filter(factor => factor != null)
                .join(' or ');

        if (filter === '') {
            filter = null;
        }
        return { pagination, filter, orderby }
    }
}
